import { FISCAL_ASSESSMENT_LEVEL } from '@/services/Hub/enums/FiscalDebtInquiry.enum'

import { recordTypeCatalog } from '../../providers/ComplianceContext'

export const getFiscalAssessmentLevel = (recordType: string) => {
  const type = recordType as (typeof recordTypeCatalog)['fiscal'][number]
  if (type === 'CND Federal') return FISCAL_ASSESSMENT_LEVEL.COUNTRY
  return FISCAL_ASSESSMENT_LEVEL.STATE
}
